import React from 'react';
import { NavigationIds } from 'components/domain/geo/navigation/GeoNavigation.types';
import {
  GeoLongTextContent,
  GeoLongTextItemOneColumn,
  GeoLongTextItemTwoColumns,
  GeoLongTextWrapper,
} from './fdr-geo-information-section-long-text.styles';

const FdrGeoInformationSectionLongText: React.FC<{
  longTextBlocks: {
    title: string;
    text: string;
  }[];
  title?: string;
}> = ({ longTextBlocks, title }) => {
  return (
    <>
      {longTextBlocks && (
        <GeoLongTextWrapper id={NavigationIds.LONG_TEXT}>
          <GeoLongTextContent>
            {title ? <h2 dangerouslySetInnerHTML={{ __html: title }} /> : null}
            {longTextBlocks?.map((item, index) => {
              if (item?.title?.length) {
                return (
                  <GeoLongTextItemTwoColumns key={index}>
                    <h3 dangerouslySetInnerHTML={{ __html: item.title }} />
                    <div dangerouslySetInnerHTML={{ __html: item.text }} />
                  </GeoLongTextItemTwoColumns>
                );
              }

              return (
                <GeoLongTextItemOneColumn
                  key={index}
                  dangerouslySetInnerHTML={{ __html: item.text }}
                />
              );
            })}
          </GeoLongTextContent>
        </GeoLongTextWrapper>
      )}
    </>
  );
};

export default FdrGeoInformationSectionLongText;
